import { render, staticRenderFns } from "./BnplRequiredDocumentsTile.vue?vue&type=template&id=34b9c736&scoped=true&"
import script from "./BnplRequiredDocumentsTile.vue?vue&type=script&lang=js&"
export * from "./BnplRequiredDocumentsTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b9c736",
  null
  
)

export default component.exports